// extracted by mini-css-extract-plugin
export var loadingSpinner = "_66-1";
export var standaloneTable = "_66-0";